/**
 * Superficie pública del bounded context Fiscal. Re-exporta desde domain-api e infra-api + UI directa.
 * Para evitar require cycles, importar solo types desde `fiscal/domain-api`.
 */
export * from './domain-api';
export * from './infra-api';

// UI — se mantiene directo en public-api (components importan de otros módulos)
export { TaxRegimeSelector } from './components/TaxRegimeSelector';
export { ArcaEnvironmentSelector } from './components/ArcaEnvironmentSelector';
export { FiscalStatusCard } from './components/FiscalStatusCard';
export type { BranchFiscalRowState } from './components/BranchFiscalSettingsPanel';
export { branchFiscalRowsFromSummaries } from './components/BranchFiscalSettingsPanel';
export { ReportsFiscalMonotributoSection } from './components/ReportsFiscalMonotributoSection';
export { BranchFiscalSettingsPanel } from './components/BranchFiscalSettingsPanel';
export { SaleFiscalComprobantePanel } from './components/SaleFiscalComprobantePanel';
export { PosFiscalBuyerSection } from './components/PosFiscalBuyerSection';
